/* =========================================================================
   ギフトラッピング オプション  (motto theme / Dawn ベース)

   仕様（新版・シンプル化）:
   - 1注文につきラッピング1点（¥330）固定。
   - 商品ページでラッピング対応商品にチェックボックスを表示（Liquid側でmetafield制御）。
   - チェックON → カートに既存ラッピングが無ければ追加、あれば追加しない（重複防止）。
   - 商品との紐づけは持たない（カートのラッピング行に並ぶ「ラッピング対象」は
     Liquid側でカート内全商品をその場で動的表示する）。
   - 数量変更・自動同期・孤児削除なし（ラッピングは常に1個固定）。

   ※ ラッピング料金はコード側で持たず、商品マスタのバリアント価格を使用します。

   設置:
   - assets/gift-wrapping.js としてアップロード
   - layout/theme.liquid の </body> 直前に:
       <script src="{{ 'gift-wrapping.js' | asset_url }}" defer="defer"></script>
   ========================================================================= */
(function () {
  'use strict';

  /* ▼▼▼ 要設定：非表示ラッピング商品の「バリアントID」(数値) ▼▼▼ */
  const WRAP_VARIANT_ID = 47122057789579;
  /* ▲▲▲ 要設定 ▲▲▲ */

  const WRAP_PROP_LABEL = 'ラッピング';     // 本体側に付与（顧客可視）
  const WRAP_PROP_VALUE = '希望する';
  const CHECKBOX_ID     = 'wrap-toggle';

  const R        = (typeof routes !== 'undefined') ? routes : {};
  const ADD_URL  = (R.cart_add_url || '/cart/add') + '.js';
  const CART_URL = (R.cart_url     || '/cart');
  const CART_JS  = CART_URL + '.js';
  const HEADERS  = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  /* ============================ 追加フロー ============================ */
  // capture フェーズで横取りし、テーマ標準の submit ハンドラより前に判定する
  document.addEventListener('submit', onSubmitCapture, true);

  function onSubmitCapture(evt) {
    const form = evt.target;
    if (!form || form.dataset.type !== 'add-to-cart-form') return;

    const checkbox = document.getElementById(CHECKBOX_ID);
    if (!checkbox || !checkbox.checked) return; // ラッピング不要 → 通常処理に任せる

    if (!WRAP_VARIANT_ID) {
      console.warn('[gift-wrapping] WRAP_VARIANT_ID が未設定です');
      return;
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();

    const idInput  = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const mainId = idInput ? parseInt(idInput.value, 10) : null;
    const qty    = qtyInput ? Math.max(parseInt(qtyInput.value, 10) || 1, 1) : 1;
    if (!mainId) return;

    addItems(form, mainId, qty);
  }

  // カート内に既にラッピングが入っていれば本体だけ追加、無ければ本体+ラッピング追加
  async function addItems(form, mainId, qty) {
    const btn        = form.querySelector('[name="add"]');
    const spinner    = btn && btn.querySelector('.loading-overlay__spinner');
    const cartDrawer = document.querySelector('cart-drawer');

    if (btn) btn.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');

    try {
      // 1) 現在のカートを確認（既存ラッピング有無）
      const cart = await fetch(CART_JS, { headers: { Accept: 'application/json' } })
        .then((r) => r.json());
      const hasWrapping = cart.items.some((i) => i.variant_id === WRAP_VARIANT_ID);

      // 2) 追加する items を組み立て
      const items = [
        { id: mainId, quantity: qty, properties: { [WRAP_PROP_LABEL]: WRAP_PROP_VALUE } }
      ];
      if (!hasWrapping) {
        items.push({ id: WRAP_VARIANT_ID, quantity: 1 }); // 1注文1ラッピング固定
      }

      const body = { items: items };
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      const data = await fetch(ADD_URL, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) })
        .then((r) => r.json());

      if (data.status) {
        console.error('[gift-wrapping] 追加エラー', data);
        window.location.href = CART_URL;
        return;
      }

      if (cartDrawer) {
        let sections = data.sections;
        if (!sections) {
          const ids = cartDrawer.getSectionsToRender().map((s) => s.id).join(',');
          sections = await fetch(`${window.location.pathname}?sections=${ids}`).then((r) => r.json());
        }
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents({ id: mainId, sections: sections });
      } else {
        window.location.href = CART_URL;
      }
    } catch (e) {
      console.error('[gift-wrapping] 追加に失敗', e);
      window.location.href = CART_URL;
    } finally {
      if (btn) btn.setAttribute('aria-disabled', 'false');
      if (spinner) spinner.classList.add('hidden');
    }
  }
})();